import { RegistrationForm } from '@/components/forms/RegistrationForm'
import { PageHero } from '@/components/layout/PageHero'
import { CheckCircle2 } from 'lucide-react'

const HERO_IMAGE = 'https://cosmosfc.org/wp-content/uploads/2022/03/S8.jpg'

const HIGHLIGHTS = [
  { label: 'Coach reply within 48 hrs' },
  { label: 'All ages: U-04 to U-18' },
  { label: 'Boys & Girls divisions' },
  { label: 'Financial aid available' },
]

export function RegisterPage() {
  return (
    <>
      <PageHero
        eyebrow="Register · Try-out · Join Cosmos"
        title="Sign up for Cosmos F.C."
        intro="To attend a tryout or open session you must register online. A Cosmos coach reaches out within 48 hours to confirm placement."
        image={HERO_IMAGE}
        crumbs={[{ label: 'Register' }]}
      />

      {/* Highlights strip */}
      <section className="bg-pitch-900 text-white border-b border-white/10">
        <div className="container-narrow py-4 flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-xs uppercase tracking-widest">
          {HIGHLIGHTS.map((h) => (
            <div key={h.label} className="flex items-center gap-2 text-white/80">
              <CheckCircle2 className="h-4 w-4 text-cosmos-gold" />
              <span>{h.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Form section with decorative background */}
      <section className="relative py-16 overflow-hidden">
        {/* Left / right decorative Cosmos images (faded) */}
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none opacity-[0.06] [background:url('https://cosmosfc.org/wp-content/uploads/2022/03/jj07-1024x682.jpg')_center/cover]"
        />
        {/* Radial ambient glow */}
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none [background:radial-gradient(circle_at_15%_20%,rgba(28,168,74,0.14),transparent_45%),radial-gradient(circle_at_85%_80%,rgba(245,197,24,0.12),transparent_45%)]"
        />

        {/* Pitch grid stripes */}
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none opacity-[0.04] [background:repeating-linear-gradient(90deg,transparent_0_60px,rgba(11,42,32,0.5)_60px_62px)]"
        />

        <div className="container-narrow relative">
          <RegistrationForm />
        </div>
      </section>
    </>
  )
}
